import { AUTH_TOKEN_STORAGE_KEY } from "@/constant/auth.constant";

export const getAuthToken = (): string | null =>
  localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);

export const setAuthToken = (token: string): void =>
  localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);

export const clearAuthToken = (): void =>
  localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
